import React from 'react';
import MainContainer from '../mainContainer';
import Study from './study';

class SimonSays extends React.Component {
    render() {
        return (
            <MainContainer>
                <Study />
            </MainContainer>
        );
    }
}

export default SimonSays;
